export const GemPagesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12098_19864)">
      <g clipPath="url(#clip1_12098_19864)">
        <rect width="20" height="20" rx="0.234474" fill="#151515" />
        <path
          d="M16.5767 2.71274L3.37011 6.84668C3.318 6.86405 3.28905 6.92195 3.30063 6.97985L4.31964 10.3322C4.33701 10.3843 4.39491 10.419 4.44702 10.4016L14.1334 7.36777C14.5966 7.22302 14.9845 6.89879 15.2103 6.46455C15.8125 5.30659 16.3104 4.1023 16.6925 2.8517C16.7273 2.75906 16.6578 2.68958 16.5767 2.71274Z"
          fill="#FFBB1C"
        />
        <path
          d="M13.4095 8.50851L5.20533 11.0734C5.15901 11.0908 5.13006 11.1371 5.14743 11.1834L6.01011 14.0146C6.02748 14.061 6.0738 14.0899 6.11433 14.0725L11.3483 12.434C11.7421 12.3124 12.0663 12.0345 12.2573 11.6698C12.7669 10.6913 13.1895 9.67226 13.508 8.61851C13.5369 8.54904 13.4732 8.48535 13.4095 8.50851Z"
          fill="#E8486C"
        />
        <path
          d="M10.2895 13.6847L6.86771 14.7558C6.82718 14.7674 6.80981 14.8079 6.82139 14.8484L7.55091 17.2397C7.56249 17.2802 7.60302 17.3033 7.64355 17.286L8.55255 17.0023C8.88257 16.8981 9.16049 16.6665 9.3226 16.3538C9.75684 15.5259 10.11 14.669 10.3821 13.7715C10.3995 13.7194 10.3474 13.6615 10.2895 13.6847Z"
          fill="#476DF2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12098_19864">
        <rect width="20" height="20" rx="2" fill="white" />
      </clipPath>
      <clipPath id="clip1_12098_19864">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
